"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShareOptions = exports.getEnableChannel = void 0;
const tslib_1 = require("tslib");
const tool_nn_1 = tslib_1.__importDefault(require("@futuweb/tool-nn"));
const nnq_1 = tslib_1.__importDefault(require("@futuweb/tool-nn/dist/nnq"));
const tool_browser_1 = require("@futuweb/tool-browser");
const constants_1 = require("./constants");
/**
 * 获取可访问app
 * @param params - 参数对象
 * @param params.channels - 渠道名称或渠道名称数组
 * @returns 返回可访问的应用列表
 */
const fetchGetEnableChannel = async ({ channels }) => {
    return new Promise((resolve, reject) => {
        try {
            nnq_1.default.getThirdPartyAppShareSupport(channels, (res) => {
                var _a;
                if (typeof res === 'string') {
                    res = JSON.parse(res);
                }
                if (Number(res.code) === 0 || ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.length)) {
                    // code = 1时 也会返回已判断的data
                    // 所以可直接根据data判断
                    const apps = res.data.filter((item) => item.share_enable).map((item) => item.app);
                    resolve(apps);
                }
                else {
                    reject(res);
                }
            });
        }
        catch (error) {
            console.error('getThirdPartyAppShareSupport catch', error);
            reject(error);
        }
    });
};
/**
 * 获取可使用的渠道
 */
const getEnableChannel = async () => {
    let isSupportGetEnableChannel = false;
    const BASE_APP_VERSION = '14.29.17107';
    if ((0, tool_browser_1.isIOS)()) {
        isSupportGetEnableChannel = tool_nn_1.default.laterThanIOS(BASE_APP_VERSION);
    }
    else {
        isSupportGetEnableChannel = tool_nn_1.default.laterThanAndroid(BASE_APP_VERSION);
    }
    if (!isSupportGetEnableChannel) {
        return [];
    }
    // 系统分享和复制链接不支持获取可使用的渠道
    const channels = Object.values(constants_1.SHARE_CHANNELS)
        .filter((channel) => ![constants_1.SHARE_CHANNELS.COPY, constants_1.SHARE_CHANNELS.SYSTEM].includes(channel));
    // 合并微信渠道，避免渠道名过长导致单行超过限制
    channels.push(constants_1.WECHAT);
    try {
        const res = await fetchGetEnableChannel({ channels });
        if (Array.isArray(res) && res.includes(constants_1.WECHAT)) {
            return [...res, constants_1.SHARE_CHANNELS.WXFRIEND, constants_1.SHARE_CHANNELS.WXTIMELINE];
        }
        return res;
    }
    catch (error) {
        console.error('getEnableChannel catch', error);
        return [];
    }
};
exports.getEnableChannel = getEnableChannel;
const getShareOptions = (shareConfig, shareType) => {
    const { title, description, imgUrl, link, images } = shareConfig;
    let shareData = {};
    // 链接分享
    if (shareType === constants_1.SHARE_TYPE.LINK) {
        shareData = {
            show_type: constants_1.SHARE_SHOW_TYPE.QuickShare,
            share_data: {
                common_model: {
                    title,
                    description,
                    url: link,
                    image_url: imgUrl,
                    ext: ''
                }
            }
        };
    }
    else {
        // 图片分享
        shareData = {
            show_type: constants_1.SHARE_SHOW_TYPE.bothButPicFirst,
            share_image: {
                images: [
                    {
                        img: images,
                        ext: {
                            useClipboardToSendText: true
                        }
                    }
                ]
            }
        };
    }
    return shareData;
};
exports.getShareOptions = getShareOptions;
//# sourceMappingURL=data:application/json;base64,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